import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import { processSteps } from "../../data/mock";

export const Process = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section id="process" className="relative">
      <div className="max-w-[1180px] mx-auto px-5 md:px-10">
        <div className="h-px bg-[rgba(10,10,10,0.08)]" />
      </div>

      <div
        ref={ref}
        className={`max-w-[1180px] mx-auto px-5 md:px-10 py-[60px] md:py-[80px] lg:py-[120px] transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <h2 className="text-[clamp(26px,4vw,40px)] font-semibold leading-[1.2] tracking-tight text-[#0A0A0A] mb-16">
          Our Process
        </h2>

        {/* Desktop: Horizontal */}
        <div className="hidden md:grid grid-cols-4 gap-0">
          {processSteps.map((step, index) => (
            <div key={step.number} className="relative pr-8">
              {/* Connector line */}
              {index < processSteps.length - 1 && (
                <div className="absolute top-[28px] left-[58px] right-0 h-px bg-[rgba(10,10,10,0.1)]" />
              )}

              <p className="text-[52px] font-light text-[rgba(10,10,10,0.1)] leading-none mb-5 tabular-nums">
                {step.number}
              </p>
              <h3 className="text-[18px] font-semibold text-[#0A0A0A] mb-3">
                {step.title}
              </h3>
              <p className="text-[15px] leading-[1.65] text-[rgba(10,10,10,0.5)]">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile: Stacked */}
        <div className="md:hidden space-y-10">
          {processSteps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Vertical connector */}
              {index < processSteps.length - 1 && (
                <div className="absolute left-[22px] top-[56px] bottom-[-40px] w-px bg-[rgba(10,10,10,0.08)]" />
              )}

              <div className="flex items-start gap-5">
                <p className="text-[40px] font-light text-[rgba(10,10,10,0.1)] leading-none flex-shrink-0 w-[44px] tabular-nums">
                  {step.number}
                </p>
                <div className="pt-1">
                  <h3 className="text-[18px] font-semibold text-[#0A0A0A] mb-2">
                    {step.title}
                  </h3>
                  <p className="text-[15px] leading-[1.65] text-[rgba(10,10,10,0.5)]">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
